// extracted by mini-css-extract-plugin
module.exports = {"workloadContainer":"backupList_workloadContainer-2mAAl","pod":"backupList_pod-3cRpW"};